<template>
  <div class="group-runtime" :style="{display: component.properties.NIHidden ? 'none' : 'block', paddingLeft: showFieldSetStyle ? 0 : '10px'}">
    <fieldset class="rc-group-fieldset" :style="{border: showFieldSetStyle ? '1px solid #D6D6D6' : 'none'}">
      <legend v-if="showFieldSetStyle">{{component.name}}</legend>
      <div v-else :class="['title', remind && 'group-remind-style']" @click="expandGroup"><i v-show="component.properties.defaultFold" :class="[component.properties.defaultFold !== 'openAndNoFolding' && 'el-icon-arrow-up', fold && 'fold']"></i>{{component.name}}</div>
      <div
        v-show="!fold"
        class="list-component-item"
        v-for="component in component.children"
        :key="component.id">
        <component
          ref="children"
          v-if="!component.properties.hidden"
          :is="component.componentType"
          :component="component"
          :disabled="disabled"
          :value="getChildrenData(component)"
          :parentPath="getCurrentPath()"
          :dialogWidth="dialogWidth"
          @input="(buildData) => updateChildValue(component.archive.columnId, buildData)"
          @initRelated="initRelated"
          @initDefaultValue="(component, callback) => callbackDefault(component, {'callback': callback})"
          @calculation="(expression) => calculation(expression)">
        </component>
      </div>
    </fieldset>
  </div>
</template>

<script>
import {containerInitMixin, componentMixin, containerMixin, calculationMixin, relFunMixin, defaultValueMixin} from './mixins'
import {ruleGenerator} from './rule'
import RcLayout from './rc-layout.vue'

export default {
  name: 'rc-group',
  mixins: [componentMixin, containerMixin, calculationMixin, relFunMixin, ruleGenerator, defaultValueMixin, containerInitMixin],
  props: ['component', 'value', 'dialogWidth', 'disabled'],
  data () {
    return {
      fold: false,
      remind: false
    }
  },
  components: {
    RcLayout
  },
  created () {
    this.fold = this.component.properties.defaultFold === 'canFoldingAndDefaultFolding'
  },
  computed: {
    // 是否可折叠
    showFieldSetStyle () {
      return !this.initState.showGroupNav && this.component.properties.defaultFold === 'openAndNoFolding'
    }
  },
  methods: {
    initRelated (component) {
      this.$emit('initRelated', component)
    },
    initDefaultValue (component, callback) {
      this.$emit('initDefaultValue', component, callback)
    },
    expandGroup () {
      // 没开启默认折叠的也不能手动折叠
      if (this.component.properties.defaultFold === 'openAndNoFolding') {
        return null
      }
      this.fold = !this.fold
    }
  }
}
</script>

<style lang="scss">
  .form-layout-run .layout-form .group-runtime {
    margin-bottom: 15px;
    .title{
      color: #737373;
      cursor: pointer;
      line-height: 28px;
      border-bottom: 1px solid #EBEBEB;
      .el-icon-arrow-up{
        margin-right: 5px;
        transition: transform .5s;
        &.fold{
          transform: rotate(180deg);
        }
      }
      &.group-remind-style{
        background: var(--light-9, #EDF7FD);
      }
    }
    .rc-group-fieldset{
      border-radius: 5px;
      min-width: 100%;
      legend{
        padding: 0 5px;
        margin-left: 50px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-group.vue